import React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import BDialog from './BDialog';
import FormGroup from '@mui/material/FormGroup';
import DialogActions from '@mui/material/DialogActions';
import Stack from '@mui/material/Stack';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import TR from './../../Trans';
import FormControlLabel from '@mui/material/FormControlLabel';

function AddSinger(props) {

  let singerName = "";
  
  const handleKeyDown = (event) => {
if (event.key === 'Enter') {
      props.onSingerCreation(singerName);
    }
  };

  return (
    <BDialog openToLeft={true} disableRestoreFocus open={props.open} onKeyDown={handleKeyDown} onClose={props.onClose}>
      <DialogTitle>{TR.cm_create_new_profile}</DialogTitle>
      <DialogContent>
        <InputLabel>{TR.cm_singers_name}</InputLabel>
        <TextField
          autoFocus
          margin="dense"
          type="text"
          fullWidth
          onChange={(e) => singerName = e.target.value}
        />
      </DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={6} justifyContent="center">
          <Button color="secondary" onClick={props.onClose}>{TR.cm_cancel}</Button>
          <Button
            color="success"
            className="muvika-dialog-action-right"
            onClick={() => props.onSingerCreation(singerName)}>{TR.cm_create}</Button>
        </Stack>
      </DialogActions>
    </BDialog>
  );
}

export default AddSinger;